import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class ApiAddressModel {
  constructor(address) {
    _defineProperty(this, "country", void 0);
    _defineProperty(this, "countryFullname", void 0);
    _defineProperty(this, "subdivision", void 0);
    _defineProperty(this, "subdivisionFullname", void 0);
    _defineProperty(this, "city", void 0);
    _defineProperty(this, "postalCode", void 0);
    _defineProperty(this, "addressLine", void 0);
    this.country = address.country;
    this.countryFullname = address.countryFullname;
    this.subdivision = address.subdivision;
    this.subdivisionFullname = address.subdivisionFullname;
    this.city = address.city;
    this.postalCode = address.postalCode;
    this.addressLine = address.addressLine;
  }
  static fromV1(address) {
    const {
      addressLine1,
      ...rest
    } = address;
    return new ApiAddressModel({
      ...rest,
      addressLine: addressLine1
    });
  }
}
//# sourceMappingURL=ApiAddress.model.js.map